<template lang="pug">
.select(:class="{'is-open': open}")
	.select-label(
		:style="styles.primary.color",
		:aria-label="data.Label") {{ data.Label }}
	.select-selected(
		tabindex="0",
		@click="toggle()",
		@keypress.enter="toggle()")
		span {{selectedText}}
	app-expand-transition
		.select-options(v-if="open", @click="toggle()")
			.select-option(
				v-for="option in data.Values",
				tabindex="0",
				:key="option.ID",
				:class="{'is-selected': option.ID == selectedID}",
				:aria-value="option.Text",
				@click="update_selection(option)",
				@keypress.enter="update_selection(option); open = false") {{option.Text}}
</template>

<script>
import { mapActions, mapGetters } from "vuex"
import Theme from '@/listing-app/mixins/Theme'
import ManageHeaderApply from "@/listing-app/mixins/ManageHeaderApply";
import ExpandTransition from "@/listing-app/components/ExpandTransition"


export default {
	name: "Select",
	mixins: [Theme, ManageHeaderApply],
	props: ["data", "terms"],
  components: {
		appExpandTransition: ExpandTransition
  },
	data() {
		return {
			open: false
		}
	},
  computed: {
    ...mapGetters(["read"]),
    selectedText() {
      if (this.terms) {
        return this.read("term").Text
      } else {
        return this.read("filters")[this.data.ID].text
      }
    },
    selectedID() {
      if (this.terms) {
        return this.read("term").ID
      } else {
        return this.read("filters")[this.data.ID].value
      }
    }
  },
  methods: {
    ...mapActions(["set"]),
    init() {
      if (!this.terms) {
        if (!this.read("filters").hasOwnProperty(this.data.ID)) {
          let defaultAvailable = false
          for (let option of this.data.Values) {
            if (option.hasOwnProperty("Default") && option.Default == true) {
              this.update_selection(option)
              defaultAvailable = true
            }
          }
          if (!defaultAvailable) {
            this.update_selection(this.data.Values[0])
          }
        }
      }
    },
    update_selection(option) {
      if (this.terms) {
        let _term
        this.read('property').Terms.forEach(term => {
          if (term.ID == option.ID) {
            _term = term
            this.set_header_apply_term(_term.ID);
          }
        })

        if (!_term) {
					console.time('load_term')
					this.set({muta: 'loaded', data: false})
          this.$api
            .get(option.Route)
            .then(res => {
							this.set({muta: 'storeTerm', data: res})
							this.set({muta: 'term', data: res})
							this.set({muta: 'loaded', data: true})
              this.set_header_apply_term(res.ID);
              console.timeEnd('load_term')
            })
            .catch(err => {
							this.set({muta: 'error', data: true})
            })
        } else {
					this.set({muta: 'term', data: _term})
        }
			} 
			else {
        let filter = this.data.ID
        let value = option.ID
        let text = option.Text

        this.set({muta: 'filters', data: { filter, value, text }})
      }
    },
    toggle() {
      this.open = !this.open
    },
    click(e) {
      if (e.type == "click") {
        if (e.target.closest(".select") != this.$el) {
          this.open = false
        }
      } else if (e.type == "keyup") {
        if (e.target.closest(".select") != this.$el) {
          this.open = false
        }
        if (e.target.closest(".select") == this.$el && e.code == "Escape") {
          this.open = false
        }
      }
    }
  },
  created() {
    this.init()
    window.addEventListener("click", this.click)
    window.addEventListener("keyup", this.click)
  },
  beforeDestroy() {
    window.removeEventListener("click", this.click)
    window.addEventListener("keyup", this.click)
  }
}
</script>

<style lang="scss" scoped>
.select {
  display: flex;
  flex-direction: column;
	position: relative;
	width: 100%;
  & > * {
    width: 100%;
  }
  &.is-open {
    z-index: 1;
  }
}

.select-label {
	font-family: $fontFamilyHeadings;
  font-size: 19px;
  text-transform: uppercase;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.select-selected {
  border: 1px solid $black;
  background-color: $offWhite;
  height: 35px;
  display: flex;
  align-items: center;
  padding: 0 10px;
  position: relative;
  cursor: pointer;
	font-size: 1.125rem;
	font-family: $fontFamilyHeadings;
	white-space: nowrap;
	
  &::selection {
		background: transparent;
    color: inherit;
  }
  &:after {
		content: "";
    height: 0;
    width: 0;
    border-top: 6px solid $black;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    margin-left: auto;
  }
	span {
		max-width: 90%;
		overflow: hidden;
	}
}

.select-options {
  border: 1px solid $black;
  border-top: none;
  display: flex;
  flex-direction: column;
  background-color: $offWhite;
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
	z-index: 10000;
	font-family: $fontFamilyHeadings;
}

.select-option {
  cursor: pointer;
  padding: 6px 15px;
	font-size: 1.125rem;
  &::selection {
    background: transparent;
    color: inherit;
  }
  &:hover {
    background: $mediumLightGray;
  }
  &.is-selected {
    background: $mediumLightGray;
  }
}
</style>

